import React from 'react'

// Marketplace card primitive.
// Variants:
//   default — white card, subtle shadow + border
//   flat    — white card, no shadow
//   muted   — slate-50 surface for nested groupings
//   accent  — soft brand-tinted card for highlight rails
//
// Padding:
//   none | sm | md | lg
//
// Usage:
//   <Card>...</Card>
//   <Card variant='accent' padding='lg' interactive>...</Card>

const VARIANT = {
  default: 'bg-white border border-slate-200 shadow-card',
  flat:    'bg-white border border-slate-200',
  muted:   'bg-slate-50 border border-slate-200',
  accent:  'bg-gradient-to-br from-brand-50 via-white to-white border border-brand-100 shadow-card',
}

const PADDING = {
  none: '',
  sm:   'p-3',
  md:   'p-5',
  lg:   'p-6 sm:p-5',
}

const Card = React.forwardRef(function Card(
  {
    as: Tag = 'div',
    variant = 'default',
    padding = 'md',
    interactive = false,
    className = '',
    children,
    ...rest
  },
  ref
) {
  const cls = [
    'rounded-card',
    VARIANT[variant] || VARIANT.default,
    PADDING[padding] ?? PADDING.md,
    interactive ? 'transition-all duration-200 hover:shadow-card-hover hover:-translate-y-0.5' : '',
    className,
  ].join(' ')

  return (
    <Tag ref={ref} className={cls} {...rest}>
      {children}
    </Tag>
  )
})

export default Card
